import script from "./BookingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingCard.vue?vue&type=script&setup=true&lang=js"

import "./BookingCard.vue?vue&type=style&index=0&id=41cbc314&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41cbc314"]])

export default __exports__